module.exports = __webpack_public_path__ + "static/media/essendon-logo.1936132a.svg";